import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/shared/base/BaseComponent';
import { DsTableEmitHolder } from '../ds-table/EsListEmitHolder';
import { DsTableActionEnum } from '../ds-table/DsTableActionEnum';

@Component({ template: '' })
export abstract class BaseItemListComponent extends BaseComponent {
  @Input()
  items: any[];

  @Input()
  formGroup: FormGroup = new FormGroup({});

  @Output()
  edit: EventEmitter<DsTableEmitHolder<any>> = new EventEmitter();

  @Output()
  delete: EventEmitter<any> = new EventEmitter();

  @Input()
  enableEditing = true;

  public isCollapsed: boolean[] = [];

  searchText: string = '';

  constructor(translateService: TranslateService) {
    super(translateService);
  }

  public emitEdit($event: any) {
    this.edit.emit({ item: $event, action: DsTableActionEnum.Edit });
  }

  public emitDelete($event: any) {
    this.delete.emit({ item: $event });
  }

  public updateSearchText($event: any) {
    this.searchText = $event.searchText;
  }
}
